import { Injectable } from '@angular/core'
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Router } from '@angular/router'
import { catchError, throwError } from 'rxjs'
import { environment } from 'src/environments/environment'

export function policyDeniedOrganization(error: any): string | undefined {
  const id = error?.error?.organizationId
  return error?.status === 403 && error?.error?.code === 'organization_sign_in_required' &&
    typeof id === 'string' && /^org_[A-Za-z0-9]+$/.test(id) ? id : undefined
}

@Injectable()
export class OrganizationSignInInterceptor implements HttpInterceptor {
  private redirecting = false
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request).pipe(catchError(error => {
      const organizationId = policyDeniedOrganization(error)
      if (request.url.startsWith(`${environment.api}/`) && organizationId &&
          !this.router.url.startsWith('/organization-access') && !this.redirecting) {
        this.redirecting = true
        void this.router.navigate(['/organization-access'], { queryParams: { organizationId } })
          .finally(() => { this.redirecting = false })
      }
      return throwError(() => error)
    }))
  }
}
